__turbopack_context__.v({
  "accent": "delivery-step-module-scss-module__0VwGKW__accent",
  "caption": "delivery-step-module-scss-module__0VwGKW__caption",
  "link": "delivery-step-module-scss-module__0VwGKW__link",
  "methods": "delivery-step-module-scss-module__0VwGKW__methods",
  "muted": "delivery-step-module-scss-module__0VwGKW__muted",
  "pin": "delivery-step-module-scss-module__0VwGKW__pin",
  "point": "delivery-step-module-scss-module__0VwGKW__point",
  "point-info": "delivery-step-module-scss-module__0VwGKW__point-info",
  "point-label": "delivery-step-module-scss-module__0VwGKW__point-label",
  "point-text": "delivery-step-module-scss-module__0VwGKW__point-text",
  "root": "delivery-step-module-scss-module__0VwGKW__root",
  "submit": "delivery-step-module-scss-module__0VwGKW__submit",
  "tip": "delivery-step-module-scss-module__0VwGKW__tip",
  "title": "delivery-step-module-scss-module__0VwGKW__title",
});
